import React, { useEffect, useState, useRef } from "react";
import {useTranslation} from "react-i18next";
import { IFeature } from '@esri/arcgis-rest-types';
import IReport from '../../../models/IReport';
import ConfigService from '../../../shared/configService';

export const ReportList = (props: any) => {
  
    const {t} = useTranslation('dashboard');

    const [state, setState] = useState({
        reports: props.reports,
        selectedGID:props.selectedGID
      });

    useEffect(() => {
        setState({
            reports: props.reports,
            selectedGID:props.selectedGID
        });
   
    }, []);
    
    return (
        <div className="containerReportList">                       
            {               
                <div className="bg-darkgreen resultBox">
                {(state.reports[0]) ? 
                    <div className="contained"> 
                    <h2 className="country-list-title">Countries Reported for {state.reports[0].rep_year}</h2>
                        {
                            
                            state.reports.sort((a: any, b: any) => (a.name0 > b.name0 ? 1 : -1)).map((report:any, i: number) =>                            
                                <ul className="list-of-countries">
                                    <li className="lstCountryData">
                                        <div className={`countryReport ${props.selectedGID==report.gid0 ? "selectedReport":""} ${(report.clickable==true)?"clickable":""}`}  key={`countryReport_${i}`}
                                                onClick={() => props.onClickedCountryState(report.gid0)} > {report.name0}
                                                {state.reports.map((report2:any, j:number) =>
                                                    report2.gid0 == report.gid0 && report.name1 
                                                    && <div className={`cityReport ${props.selectedGID==report2.gid1 ? "selectedReport":""}`} key={`stateReport_${j}`}
                                                    onClick={e => {e.stopPropagation(); props.onClickedCountryState(report2.gid1)}} >{report2.name1}</div>
                                                )}
                                        </div>
                                    </li>
                                </ul>
                            )
                        }                                                                  
                    </div>
                    : <h2 className="country-list-title"></h2>
                } 
                </div>                
            }
        </div>
    )
}